/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { listDipApplicationsQueryResponseSchema } from '../schemas/listDipApplicationsSchema.ts';
import type { ListDipApplications500, ListDipApplicationsQueryResponse } from '../types/ListDipApplications.ts';

export const listDipApplicationsSuspenseQueryKey = () => ['DIP_COMPONENT', { url: '/user/applications' }] as const;

export type ListDipApplicationsSuspenseQueryKey = ReturnType<typeof listDipApplicationsSuspenseQueryKey>;

/**
 * @description User API to retrieve a list of DIP applications.
 * @summary Get DIP Applications by User
 * {@link /user/applications}
 */
export async function listDipApplicationsSuspense(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<ListDipApplicationsQueryResponse, ResponseErrorConfig<ListDipApplications500>, unknown>({
    method: 'GET',
    url: `/user/applications`,
    ...requestConfig,
  });
  return listDipApplicationsQueryResponseSchema.parse(res.data);
}

export function listDipApplicationsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = listDipApplicationsSuspenseQueryKey();
  return queryOptions<
    ListDipApplicationsQueryResponse,
    ResponseErrorConfig<ListDipApplications500>,
    ListDipApplicationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return listDipApplicationsSuspense(config);
    },
  });
}

/**
 * @description User API to retrieve a list of DIP applications.
 * @summary Get DIP Applications by User
 * {@link /user/applications}
 */
export function useListDipApplicationsSuspense<
  TData = ListDipApplicationsQueryResponse,
  TQueryKey extends QueryKey = ListDipApplicationsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        ListDipApplicationsQueryResponse,
        ResponseErrorConfig<ListDipApplications500>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? listDipApplicationsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...listDipApplicationsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<ListDipApplications500>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
